module.exports = __webpack_public_path__ + "static/media/demo-video.068483dd.jpg";